module.exports = __webpack_public_path__ + "img/wechat.13bf72e6.png";